import { render, staticRenderFns } from "./SlideControl.vue?vue&type=template&id=787963a7&scoped=true&"
import script from "./SlideControl.vue?vue&type=script&lang=ts&"
export * from "./SlideControl.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./SlideControl.vue?vue&type=style&index=0&id=787963a7&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "787963a7",
  null
  ,true
)

component.options.__file = "SlideControl.vue"
export default component.exports